package com.example.crashbit

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import kotlinx.serialization.Serializable
import kotlin.random.Random

@Serializable
data class Nebula(
    val id: Long = Random.nextLong(),
    val name: String,
    @Serializable(with = OffsetSerializer::class)
    val position: Offset,
    val radius: Float,
    val density: Float,
    @Serializable(with = ColorSerializer::class)
    val color: Color,
    val composition: Map<String, Float>
)
